import { Fragment } from 'react/jsx-runtime';

export default function BrSplitter(props: { label: string }) {
  if (!props.label) {
    return null;
  }
  return (
    <>
      {props.label.split('\n').map((x, i) => (
        <Fragment key={`${x}_${i}`}>
          {i > 0 && <br />}
          {x}
        </Fragment>
      ))}
    </>
  );
}
